var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[(!_vm.readonly)?[_c('a-input',{staticStyle:{"width":"120px","margin-right":"10px"},attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}),_vm._v("天 ")]:[_vm._v(_vm._s(_vm.val)+"天")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }